export default "__VITE_ASSET__CvjKaHOS__"